import { Address } from "@/api/address/types";
import { Address as SharedAddress } from "@/types/api/shared";

export const getValidation = (fieldName) =>
  ({
    postcode: (value) => value.toString().match(/^\d{0,4}$/),
  })[fieldName];

export const transformAddress = (
  address: SharedAddress = { street: "", number: "", city: "", postcode: "" }
): Address => {
  return {
    street: address.street,
    streetnumber: address.number,
    city: address.city,
    postalCode: address.postcode,
  };
};
